module.exports = __webpack_public_path__ + "h5/img/detail_1.3fe08a14.png";